const styles = `:host {
  border-top: 1px solid;
  border-color: var(--goto-field-01);
  margin: 8px 0;
  height: 1px;
  display: flex;
}`; export default styles;